import {
    RequestConfigFunction,
} from 'app/types/request.types'
import {
    RequestKeys,
} from 'app/hooks/useRequest'

type LoggerPairingRequests = {
    delete: RequestConfigFunction<{id: number, serialNumber: string}>,
    update: RequestConfigFunction<{serialNumber: string}>,
    add: RequestConfigFunction<{serialNumber: string}>,
    [RequestKeys.getDeletedLoggerHistory]:
        RequestConfigFunction<{serialNumber: string, params?: Record<string, any>}>,
}

const loggerPairingRequests: LoggerPairingRequests = {
    delete: ({
        id, serialNumber,
    }) => {
        return {
            url: `container/${serialNumber}/logger-pairing/${id}/delete`,
            method: 'PATCH',
        }
    },
    update: ({
        serialNumber,
    }) => {
        return {
            url: `container/${serialNumber}/logger-pairing/logger-removal`,
            method: 'PATCH',
        }
    },
    add: ({
        serialNumber,
    }) => {
        return {
            method: 'POST',
            url: `container/${serialNumber}/logger-pairing`,
            domainName: 'LoggerInformationDto',
        }
    },
    [RequestKeys.getDeletedLoggerHistory]: ({
        serialNumber,
        params,
    }) => {
        const newParams = {
            ...params,
            sort: params?.sort || {
                direction: 'desc',
                field: 'deletedOn',
            },
            rows: params?.rows || 200,
        }

        return {
            url: `container/${serialNumber}/logger-pairing/filter-request/deleted`,
            method: 'POST',
            ...newParams,
        }
    },
}

export default loggerPairingRequests
